/* 二级尺寸 */
// 字号
export const font_grade_1 = 24; /* 页面大标题、大数字、结果等信息等 */
export const font_grade_2 = 20; /* 弹层组件选中态、数据披露 */
export const font_grade_3 = 18; /* 顶部三大Tab、弹窗标题 */
export const font_grade_4 = 17; /* 卡片标题、二级页面标题、文字按钮 */
export const font_grade_5 = 16; /* 强调文本、弹层文本、大按钮文本等 */
export const font_grade_6 = 15; /* 列表文本、小标题、中按钮文本 */
export const font_grade_7 = 14; /* 描述段落文本、中按钮文本 */
export const font_grade_8 = 12; /* 辅助信息、小按钮文本 */
export const font_grade_9 = 11; /* 基准标签文字 */
export const font_grade_10 = 10; /* 最小次级信息 */
export const font_grade_11 = 9; /* 小号标签文字 */
export const font_grade_12 = 7; /* 状态标签文字 */
// 行高
export const line_height_grade_1 = 34; /* 页面大标题、大数字、结果等信息等 */
export const line_height_grade_2 = 28; /* 弹层组件选中态、数据披露 */
export const line_height_grade_3 = 26; /* 顶部三大Tab、弹窗标题 */
export const line_height_grade_4 = 25; /* 卡片标题、二级页面标题、文字按钮 */
export const line_height_grade_5 = 24; /* 强调文本、弹层文本、大按钮文本等 */
export const line_height_grade_6 = 23; /* 列表文本、小标题、中按钮文本 */
export const line_height_grade_7 = 21; /* 描述段落文本、中按钮文本 */
export const line_height_grade_8 = 18; /* 辅助信息、小按钮文本 */
export const line_height_grade_9 = 16; /* 基准标签文字 */
export const line_height_grade_10 = 15; /* 最小次级信息 */
export const line_height_grade_11 = 14; /* 小号标签文字 */
export const line_height_grade_12 = 10; /* 状态标签文字 */
// 字重
export const font_weight_medium = '500';
export const font_weight_normal = '400';
export const font_weight_bold = '500';
/* 三级尺寸 */
/* switch */
export const switch_size_width = 46;
export const switch_size_height = 24;
export const switch_size_text_label = font_grade_5;
export const switch_label_left_margin = 10;
/* tooltip组件 */
export const tooltip_size_text = font_grade_7; /* tip泡泡中的文字尺寸 */
export const tooltip_size_line_height = line_height_grade_7; /* tip泡泡中的文字行高 */
export const tooltip_size_container_horizontal_padding = 16; /* tip泡泡中的水平padding */
export const tooltip_size_container_vertical_padding = 8; /* tip泡泡中的垂直padding */
export const tooltip_size_container_border_radius = 4; /* tip泡泡的圆角大小 */
export const tooltip_size_container_arrow_half_width = 5; /* tip泡泡的箭头的一半宽度 */
/* icon 组件 */
export const icon_img_width = 24; /* icon中的图片宽度 */
export const icon_img_height = 24; /* icon中的图片高度 */
/* checkbox组件 */
export const checkbox_size_icon = 20; /* checkbox中选中图标的icon/数字类型时内部文字的尺寸 */
export const checkbox_size_container_width = 20; /* checkbox容器宽度 */
export const checkbox_size_container_height = 20; /* checkbox容器高度 */
export const checkbox_size_text_container_width = 20; /* checkbox数字类型文字容器宽度 */
export const checkbox_size_text_container_height = 20; /* checkbox数字类型文字容器高度 */
export const checkbox_size_text_label = font_grade_5; /* checkbox中label文字字号 */
export const checkbox_size_line_height_label = line_height_grade_5; /* checkbox中label文字行高 */
export const checkbox_size_number_text = font_grade_8; /* checkbox中Number类型时的文字字号 */
export const checkbox_label_margin = 8; /* checkbox中label文字与radio的间距 */
/* radio组件 */
export const radio_size_icon = 20; /* radio中选中图标的icon/数字类型时内部文字的尺寸 */
export const radio_size_container_width = 20; /* radio容器宽度 */
export const radio_size_container_height = 20; /* radio容器高度 */
export const radio_size_text_label = font_grade_5; /* radio中label文字字号 */
export const radio_size_line_height_label = line_height_grade_5; /* radio中label文字行高 */
export const radio_label_margin = 8; /* radio中label文字与radio的间距 */
/* notice-bar 组件 */
export const notice_bar_size_height = 40; /* notice-bar 高度 */
export const notice_bar_size_padding_vertical = 10; /* notice-bar 内容上下间距 */
export const notice_bar_size_padding_horizontal = 19; /* notice-bar 内容左右间距 */
export const notice_bar_size_padding_horizontal_round = 16; /** notice bar round 内容左右间距 */
export const notice_bar_size_text_font_size = font_grade_7; /* notice-bar 内容字号 */
export const notice_bar_size_text_line_height = line_height_grade_7; /* notice-bar 内容行高 */
export const notice_bar_size_border_radius = 8; /* notice-bar 圆角大小 */
export const notice_bar_size_content_left_margin = 4;
export const notice_bar_size_content_right_margin = 16;
export const notice_bar_icon_size = 16;
/* dialog 组件 */
export const dialog_size_width = 280; /* 弹窗宽度 */
export const dialog_size_border_radius = 12; /* 弹窗圆角 */
export const dialog_size_body_padding = 24; /* 弹窗padding */
export const dialog_size_header_font_size = font_grade_3; /* 弹窗标题字号 */
export const dialog_size_header_line_height = line_height_grade_3; /* 弹窗标题行高 */
export const dialog_size_header_font_weight = font_weight_bold; /* 弹窗标题字重 */
export const dialog_size_content_font_size = font_grade_5; /* 弹窗内容字号 */
export const dialog_size_content_line_height = line_height_grade_5; /* 弹窗内容行高 */
export const dialog_size_content_font_weight = font_weight_normal; /* 弹窗内容字重 */
export const dialog_size_action_font_size = font_grade_4; /* 弹窗按钮字号 */
export const dialog_size_action_line_height = line_height_grade_4; /* 弹窗按钮行高 */
export const dialog_size_action_font_weight = font_weight_normal; /* 弹窗按钮字重 */
export const dialog_size_action_height = 48; /* 弹窗操作区域高度 */
/* toast 组件 */
export const toast_size_container_width = 120;
export const toast_size_info_container_min_width = 120;
export const toast_size_info_container_max_width = 240;
export const toast_size_container_height = 120;
export const toast_size_gap_icon_content = 11;
export const toast_size_info_padding_vertical = 12;
export const toast_size_info_padding_horizontal = 20;
export const toast_size_normal_padding_vertical = 20;
export const toast_size_normal_padding_horizontal = 11;
export const toast_size_icon = 48;
export const toast_size_normal_text = font_grade_7;
export const toast_size_info_text = font_grade_5;
export const toast_size_normal_line_height = line_height_grade_7;
export const toast_size_info_line_height = line_height_grade_5;
export const toast_size_container_border_radius = 8;
export const toast_size_text_margin_top = 7;
/* empty-state 组件 */
export const empty_state_size_padding = 48; /* empty-state 标题字号 */
export const empty_state_size_title_font_size = font_grade_3; /* empty-state 标题字号 */
export const empty_state_size_title_line_height = line_height_grade_3; /* empty-state 标题行高 */
export const empty_state_size_description_font_size = font_grade_6; /* empty-state 描述字号 */
export const empty_state_size_description_line_height = line_height_grade_6; /* empty-state 描述行高 */
export const empty_state_size_link_font_size = 13; /* empty-state 链接字号 */
export const empty_state_size_link_line_height = 22; /* empty-state 链接行高 */
/* picker组件 */
export const picker_size_title_bar_height = 56; /* picker title-bar 高度 */
export const picker_size_scroll_container_height = 260; /* picker 滚动区域高度 */
export const picker_size_scroll_item_height = 56; /* picker 单个项高度 */
export const picker_size_scroll_top_bottom_height = 102; /* picker 容器上方/下方留白高度 */
export const picker_size_clickable_text = font_grade_5; /* 可点击文字字号 */
export const picker_size_title_text = font_grade_4; /* 顶部title字号 */
export const picker_size_scroll_item_normal_text = font_grade_5; /* 可滑动item未选中字号 */
export const picker_size_scroll_item_selected_text = font_grade_2; /* 可滑动item选中时字号 */
/* input组件 */
export const input_size_container_default_width = '100%';
export const input_size_container_mini_height = 24;
export const input_size_container_small_height = 56;
export const input_size_container_large_height = 60;
export const input_size_font = font_grade_5;
export const input_size_arrow = 16;
export const input_size_clear = 20;
export const input_size_line_height = line_height_grade_5;
export const input_size_icon_height = 16;
export const input_size_icon_width = 16;
export const input_size_icon_margin_left = 12;
export const input_size_border_width = 1;
/* textarea组件 */
export const textarea_size_container_default_width = '100%';
export const textarea_size_container_default_height = 118;
export const textarea_size_counter_height = 20;
export const textarea_size_counter_margin_top = 2;
export const textarea_size_padding_left = 12;
export const textarea_size_padding_right = 12;
export const textarea_size_padding_top = 8;
export const textarea_size_padding_bottom = 8;
export const textarea_size_border_radius = 4;
export const textarea_size_border_width = 1;
/** switch组件 */
export const switch_size_container_default_width = 48;
export const switch_size_container_default_height = 26;
export const switch_size_thumb_border_width = 1;
/* form-item组件 */
export const formItemTokenSizeContainerNormalMinHeight = 56;
export const formItemTokenSizeContainerLargeMinHeight = 60;
export const formItemTokenSizeLabelWidth = 88;
export const formItemTokenSizeLabelFont = 16;
export const formItemTokenSizeLineHeight = 24;
export const formItemTokenSizePadding = 19;
/* ActionSheet组件 */
export const action_sheet_size_title = font_grade_7; // 标题文字大小
export const action_sheet_size_text = font_grade_4; // 选项文字大小
export const action_sheet_size_option_height = 64; // 选项高度
/* navBar组件 */
// 导航栏高度
export const navBarTokenSizeHeightBar = 45;
// 导航栏字体大小
export const navBarTokenSizeTitleFont = font_grade_4;
// 按钮文字尺寸
export const navBarTokenSizeTextFont = font_grade_4;
// 按钮icon尺寸
export const navBarTokenSizeIconFont = 19; // var(--font-grade-4 + 2px)
// 左右按钮高度
export const navBarSizeBtn = 40;
/* image-preview 组件 */
// 分页指示器区域高度
export const imagePreviewTokenSizeIndicatorHeight = 56;
// 分页指示器字号
export const imagePreviewTokenSizeIndicatorFontSize = font_grade_5;
/* Stepper组件 */
export const stepper_size_number = font_grade_6; // 数字字体大小
export const stepper_size_icon = 17; // 加减icon字体大小 var(font_grade_6 + 2px)
export const stepper_size_width_press_area = 35; // 加减icon点击区域宽度
export const stepper_size_height = 32; // 组件高度(normal)
export const stepper_size_height_small = 28; // 组件高度(small)
export const stepper_size_input_width = 36; // 数字框默认宽度
export const stepper_size_number_border = 4; // 数字框边框半径
export const stepper_size_number_padding_horizontal = 9; // 数字框横向padding
/* SwipeCell组件 */
export const swipe_cell_size_text = font_grade_7; // 按钮文字尺寸
export const swipe_cell_size_btn_min_width = 52; // 按钮最小宽度
/* textarea组件 */
export const textarea_size_font = font_grade_5;
export const textarea_size_line_height = 20;
/* uploader 组件 */
export const uploader_size_width = 88; /* 上传卡片宽度 */
export const uploader_size_height = 88; /* 上传卡片高度 */
export const uploader_size_border_radius = 8; /* 上传卡片圆角 */
export const uploader_size_icon = 24; /* 上传卡片图标尺寸 */
export const uploader_size_text_font_size = font_grade_8; /* 上传卡片文案字号尺寸 */
export const uploader_size_text_line_height = line_height_grade_8; /* 上传卡片文案行高尺寸 */
export const uploader_size_card_padding = 8; /* 上传卡片文案行高尺寸 */
/* bottom-panel 组件 */
export const bottom_panel_size_border_radius = 16; // 圆角大小
export const bottom_panel_size_header_font_size = font_grade_2; // 标题字号
export const bottom_panel_size_header_line_height = line_height_grade_2; // 标题行高
export const bottom_panel_size_header_font_weight = font_weight_medium; // 标题字重
export const bottom_panel_size_content_font_size = font_grade_6; // 内容字号
export const bottom_panel_size_content_line_height = line_height_grade_6; // 内容行高
/* bottom-dialog 组件 */
export const bottom_dialog_size_header_font_size = font_grade_2; // 标题字号
export const bottom_dialog_size_header_line_height = line_height_grade_2; // 标题行高
export const bottom_dialog_size_header_font_weight = font_weight_medium; // 标题字重
export const bottom_dialog_size_content_font_size = font_grade_6; // 内容字号
export const bottom_dialog_size_content_line_height = line_height_grade_6; // 内容行高
/* tabs 组件 */
// 标签栏字体大小
export const tab_size_nav_text = font_grade_6; /* 标签栏字体大小 */
export const tab_size_nav_text_height = 38; /* 标签栏字体高度 */
export const tab_size_nav_slider_height = 2; /* 标签栏slider高度 */
export const tab_nav_slider_border_radius = 1; /* 标签栏slider边框圆角 */
/** button 组件 */
// button大小，height
export const button_size_height = {
    tiny: 28,
    mini: 32,
    small: 36,
    medium: 40,
    large: 48,
    huge: 56,
};
// paddingHorizontal
export const button_size_padding_horizontal = {
    tiny: 12,
    mini: 12,
    small: 12,
    medium: 16,
    large: 24,
    huge: 32,
};
// title字体大小
export const button_title_font_size = {
    tiny: font_grade_8,
    mini: font_grade_8,
    small: font_grade_7,
    medium: font_grade_7,
    large: font_grade_6,
    huge: font_grade_5,
};
export const button_border_width = 1;
export const button_size_icon_width = {
    tiny: font_grade_7,
    mini: font_grade_5,
    small: font_grade_5,
    medium: font_grade_5,
    large: font_grade_1,
    huge: font_grade_1,
};
export const button_size_icon_margin_right = 4;
// Badge组件
export const badge_size_padding_horizontal = {
    number: 4,
    text: 4,
    dot: 3,
    warn: 4,
};
export const badge_title_font_size = {
    text_small: 7,
    text_large: 10,
    number_small: 12,
    number_large: 12,
};
// 徽标高度
export const badge_size_height = {
    text_small: 11,
    text_large: 16,
    dot_small: 6,
    dot_large: 8,
    warn_small: 16,
    warn_large: 24,
    number_small: 16,
    number_large: 16,
};
// 徽标边框大小
export const badge_size_border_width = {
    number: 1,
    text: 1,
    dot: 2,
    warn: 1,
};
// 徽标警告图标宽度
export const badge_size_warn_icon_width = {
    small: 1.5,
    large: 2.5,
};
// 徽标警告图标高度
export const badge_size_warn_icon_height = {
    small: 8.5,
    large: 14,
};
export const badge_size_warn_icon_size = 9;
export const loading_size = 40; /* loading尺寸 */
// 导航组件
export const nav_bar_size_text_font_size = font_grade_4;
export const nav_bar_size_title_font_size = font_grade_3;
export const nav_bar_text_font_weight = font_weight_normal;
export const nav_bar_title_font_weight = font_weight_bold;
// 搜索栏组件
export const searchbar_size_input_height = 40;
export const searchbar_size_input_padding_horizontal = 12;
export const searchbar_size_left_content_margin_right = 18;
export const searchbar_size_input_content_margin = 12;
export const searchbar_size_right_content_text = 16;
export const searchbar_size_search_icon = 16;
export const searchbar_size_search_icon_ = 6;
export const searchbar_size_input_icon_margin = 5;
export const searchbar_size_input_font = 16;
/* FormItem 组件 */
export const formitem_padding = 19; // 容器左右padding
export const formitem_size_small_min_height = 56; // 小尺寸的最小高度
export const formitem_size_large_min_height = 60; // 大尺寸的最小高度
export const formitem_label_width = 88; // 左侧标题容器的宽度
export const formitem_label_margin_right = 16; // 左侧标题容器的右边距
export const formitem_label_font = font_grade_5; // 标题字体大小
export const formitem_line_height = line_height_grade_5; // 行高
export const formitem_content_margin_top = 16; // content上边距
export const formitem_vertical_padding = 16; // 容器最小上下边距
export const formitem_sub_title_font = font_grade_8; // 副标题字体大小
export const formitem_sub_title_line_height = line_height_grade_9; // 副标题字体行高
export const formitem_red_point_size = 4; // require红点大小
export const formitem_red_point_margin_left = 3; // require红点左边距
export const formitem_message_font = font_grade_8; // 错误信息提示字体大小
export const formitem_message_line_hight = line_height_grade_8; // 错误信息提示行高
// FormItem大小，minHeight
export const form_item_size_min_height = {
    small: formitem_size_small_min_height,
    large: formitem_size_large_min_height,
};
